import { createContext } from "react";
import { MessagesRecord } from "./translations/TranslatedText";
import { IState } from "./QuizzBuilder/reducer/reducer";
import { IActions } from "./QuizzBuilder/reducer/actions";
import { defaultMessages } from "./translations/TranslatedText";
import defaulttoolBox from "./ToolBox/index";

interface IContextProps {
  toolBox: Array<Object>;
  language: string;
  messages: MessagesRecord;
  quizTypeName: string,
  templateTypeName?: string,
  quizCorrectAnswer: Object
}

export type IQuizzContext = IContextProps;
export type IQuizzBuilderContext = IContextProps & {
  state: IState;
  dispatch: (arg: IActions) => void;
  updateCorrectAnswer: (data)=>void;
};

// default context
export function getDefaultContext({
  messages,
  language,
  toolBox,
  quizTypeName,
  quizCorrectAnswer,
  templateTypeName,
}: Partial<IContextProps>) {
  return {
    messages: messages || defaultMessages,
    language: language || "en",
    toolBox: toolBox || defaulttoolBox(),
    quizTypeName: quizTypeName || ""    ,
    templateTypeName: templateTypeName || "",
    quizCorrectAnswer: quizCorrectAnswer || {}
  };
}

/* Quiz context */
const QuizzContext = createContext<IQuizzContext | IQuizzBuilderContext>(
  getDefaultContext({})
);

export default QuizzContext;
